// safely get a list of verse id's from a passageId
const getVerseIdsFromPassageId = (passageId: string): string[] => {
  let [startId, endId] = passageId.split("-");
  endId = endId || startId;
  const verseIds = [];
  const [startBook, startChapter, startVerse] = startId.split(".");
  const [endBook, endChapter, endVerse] = endId.split(".");

  const startVerseNumber = Number(startVerse);
  const endVerseNumber = Number(endVerse);
  const maxVerseNumber =
    startBook === endBook && startChapter === endChapter ? endVerseNumber : 150;

  for (
    let verseNumber = startVerseNumber;
    verseNumber <= maxVerseNumber;
    verseNumber++
  ) {
    verseIds.push([startBook, startChapter, verseNumber].join("."));
  }

  return verseIds;
};

export default getVerseIdsFromPassageId;
